export const emailOrganizationDomain = 'uinno.io';

export const storageUserKey = 'user';
